import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 2v20h20V2H2Zm8.5 15.1-5.6-5.6L7 9.4l3.4 3.4 6.4-6.4 2.1 2.1-8.4 8.6Z", fill: "#000" }));
export default SvgCheckmark;
